import { makeStyles } from '@material-ui/core'

export const PageNotFoundStyle = makeStyles((theme) => ({
  root: {
    width: 'calc(100% - 300px)',
    height: '100vh',
    transition: 'all 0.2s ease-in-out',
    marginLeft: '300px',
    paddingTop: '66px',
  },
  formContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: `calc(100vh - ${theme.mixins.toolbar['@media (min-width:600px)'].minHeight}px)`,
    maxWidth: 500,
    margin: `0 auto`,
    '& img': {
      width: '100%',
    },
  },
  section: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  label: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  backButton: {
    backgroundColor: '#8150e2',
    fontSize: '16px',
    fontWeight: '500',
    padding: '5px 24px',
    borderRadius: '30px',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#c1c2fa',
    },
  },
}))
